<template>
    <b-navbar type="is-primary"  fixed-top>
        <template slot="brand">
            <b-navbar-item tag="li" @click="reset()">
                <a @click="reset()">
                    <img src="/img/mw-logo.png" alt="MW" title="Übersicht">
<!--                    <b-icon pack="fad" icon="calendar-alt" size="is-medium" type="is-light"></b-icon>-->
                </a>
            </b-navbar-item>
        </template>
        <template slot="start" v-if="$route.name == 'home'">
            <b-navbar-item v-if="$root.env.home.view == 'settings'" tag="li">
                <b-icon pack="fad" icon="caret-right"></b-icon>
                <b>Einstellungen</b>
            </b-navbar-item>
            <b-navbar-item v-else tag="li">
                    <b>{{$root.env.config.AppName}}</b>
            </b-navbar-item>
        </template>
        <template slot="start" v-if="$route.name == 'event' || $route.name == 'eventpage'">
            <b-navbar-item tag="li">
                <b>{{ $root.event.name }}</b>
            </b-navbar-item>
            <b-navbar-item tag="li">
                <div class="buttons">
                    <b-button type="is-success" pack="fad" icon-right="save"
                              @click="$root.saveEvent($route.params.id,true)"></b-button>
                </div>
            </b-navbar-item>
            <b-navbar-item v-if="$root.env.lastSave" tag="li">
                {{ $root.env.lastSave }}&nbsp;zul. gespeichert
            </b-navbar-item>
            <b-navbar-item tag="li" v-if="$root.env.loading.active !== 0">
                <div class="buttons">
                    <b-button loading type="is-text"></b-button>
                </div>
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item v-if="infos">
                <b-dropdown hoverable aria-role="list">
                    <button class="button is-info" slot="trigger">
                        <b-icon pack="fad" icon="info-circle"></b-icon>
                    </button>
                    <b-dropdown-item v-for="e in infos" aria-role="listitem" custom>{{e.msg}}<br>
                        <a v-if="e.click" @click="e.click">
                            <b-icon pack="fad" icon="medkit" size="is-small" type="is-warning">
                            </b-icon>
                        </a>
                    </b-dropdown-item>
                </b-dropdown>
            </b-navbar-item>
            <b-navbar-item v-if="warnings">
                <b-dropdown hoverable aria-role="list">
                    <button class="button is-warning" slot="trigger">
                        <b-icon pack="fad" icon="exclamation-triangle"></b-icon>
                    </button>
                    <b-dropdown-item v-for="e in warnings" aria-role="listitem"  @click="e.click">{{e.msg}}
                    </b-dropdown-item>
                </b-dropdown>
            </b-navbar-item>
            <b-navbar-item v-if="errors">
                <b-dropdown hoverable aria-role="list">
                    <button class="button is-danger" slot="trigger">
                        <b-icon pack="fad" icon="exclamation-triangle"></b-icon>
                    </button>
                    <b-dropdown-item v-for="e in errors" aria-role="listitem"  @click="e.click">{{e.msg}}
                    </b-dropdown-item>
                </b-dropdown>
            </b-navbar-item>
            <b-navbar-item tag="li">
                <b-icon pack="fad" icon="clock"></b-icon>
                <span style="margin-left:5px">{{ time }}</span>
            </b-navbar-item>
            <b-navbar-dropdown hoverable>
                <template slot="label">
                    <b-icon pack="fad" icon="user"></b-icon>
                    <span style="margin-left:5px">{{ $root.env.auth.credentials.username }}</span>
                </template>
                <b-navbar-item tag="li">
                        <a class="" @click="$root.env.auth.logout()">
                            Abmelden
                        </a>
                </b-navbar-item>
            </b-navbar-dropdown>

            <b-navbar-item v-if="$route.name == 'home'" tag="li">
                <button class="button is-light is-outlined" @click="$root.env.home.view = $root.env.home.view == 'home' ? 'settings' : 'home'">
                    <b-icon pack="fad" :icon="$root.env.home.view == 'home' ? 'cogs' : 'home-lg'"></b-icon>
                </button>
            </b-navbar-item>

        </template>
    </b-navbar>
</template>

<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                time: '00:00',
            }
        },
        methods: {
            reset() {
                this.$root.event = {}
                this.$root.users = []
                this.$root.getEvents()
                this.$root.env.home.view = 'home'
                this.$router.push({
                    path: '/'
                })
            },
            updateTime(){
                let today = new Date();
                let h = '00' + today.getHours();
                let m = '00' + today.getMinutes();
                this.time = h.slice(-2) + ':' + m.slice(-2)
            }
        },
        created() {
            this.updateTime()
            setInterval(this.updateTime, 1000);
        },
        computed: {
            errors() {
                let r = []

                if (typeof this.$root.settings.firms === 'undefined' || this.$root.settings.firms.length === 0) {
                    r.push({
                        msg: 'Es ist noch keine Firmierung angelegt.',
                        click: () => true
                    })
                }
                if (this.$route.name === 'event' || this.$route.name === 'eventpage') {
                    if (this.$root.event.slug == '') {
                        r.push({
                            msg: 'Es ist kein Slug vergeben.',
                            click: () => {
                                this.$root.env.view.activeTab = 1
                                this.$root.env.view.tabArrangement = 0
                            }
                        })
                    }
                }
                if (this.$route.name === 'event' || this.$route.name === 'eventpage') {
                    if (typeof this.$root.event.list === 'undefined') {
                        r.push({
                            msg: 'Es ist keine Liste angegeben.',
                            click: () => {
                                this.$root.env.view.activeTab = 1
                                this.$root.env.view.tabArrangement = 0
                            }
                        })
                    }
                }

                return r.length > 0 ? r : false
            },
            warnings() {
                let r = []

                return r.length > 0 ? r : false
            },
            infos() {
                let r = []

                return r.length > 0 ? r : false
            }
        }
    }
</script>

<style>
    nav.navbar {
        margin-bottom: 15px;
    }

    @media screen and (max-width: 768px) {

        nav.tabs li:not(.is-active) {
            -webkit-box-flex: 0;
            -ms-flex-positive: 0;
            flex-grow: 0;
            -ms-flex-negative: 1;
            flex-shrink: 1;
        }

        .tabs .icon {
            margin-left: 0.5em;
        }

        .tabs li span.icon + span {
            display: none !important;
        }
    }

    .tabs li {
        transition: flex-grow 1s ease;
    }

    .border-right {
        border-right: 1px rgb(156, 156, 156) solid;
    }
</style>
